<div class="atn-ds-code">
  @let label = labelSg();
  @let syntaxSelector = syntaxSelectorSg();

  <!-- If we have 'label' or 'syntaxSelector' we display header -->
  @if (label || syntaxSelector) {
    <div class="atn-ds-code__header">
      @if (label) {
        <span class="atn-ds-code__label"> {{ label }} </span>
      }

      @if (syntaxSelector) {
        <atn-ds-select-single
          (valueChange)="onSyntaxChangeHandler($event)"
          [items]="availableSyntaxesSg()"
          [value]="syntaxIdSg()"
          [required]="true"
          class="atn-ds-code__syntax-selector"
        />
      }
    </div>
  }
  <div
    class="atn-ds-code__container"
    #container
  >
    @if (canBeFullscreen) {
      <button
        class="atn-ds-code__fullscreen-toggle"
        (click)="toggleFullscreen()"
      >
        {{ isFullscreen ? '🗕' : '⛶' }}
      </button>
    }
  </div>
</div>
